var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#32A4F2",
    d: "M16.12 16.333a4.05 4.05 0 0 0-.5-1.988c-.801-1.477-2.746-1.923-3.058-3.73a3.1 3.1 0 0 1 2.318-3.58c1.384-.338 2.806.43 3.977 1.09c-.012 2.973-1.048 5.776-2.736 8.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA12",
    d: "M12.285 7.618a4.1 4.1 0 0 1 1.381-1.2c-2.962-.287-5.922.231-8.523 1.714c.003 1.62.129 3.706 1.669 4.606c1.73 1.012 4.018.069 4.557-1.836c.325-1.182.122-2.198.916-3.284"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CBAAD",
    d: "M10.443 13.625c-1.264.726-2.876.73-4.135-.007c1.163 2.65 3.176 4.97 5.692 6.418c1.748-1.032 3.7-2.255 2.969-4.608c-.564-1.902-2.82-2.778-4.526-1.804"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXem);
export default __webpack_public_path__ + "static/media/xem.bdb6dd0a613f02968878348a8fe10641.svg";
export { ForwardRef as ReactComponent };